<template>
  <div class="boxView" :style="{'width':'100%','height':'310px'}" ref="boxView">
    <canvas :id="canvasId" class="monitor-canvas" :width="canvasWidth" :height="canvasHeight"></canvas>
  </div>
</template>

<script>
const CONFIG = {
  // 画布基础配置
  CANVAS: {
    VIEWPORT_WIDTH: '', // 可视区域(1屏幕)宽度
    WIDTH: '', // 画布宽度
    HEIGHT: '', // 画布高度
    BG_COLOR: '#FFFFFF', // 背景颜色
    GRID_COLOR: '#E4E4E4', // 网格线颜色
    GRID_LINE_WIDTH: 1, // 网格线宽
    PADDING_TOP: 10, // 顶部留白
    PADDING_LEFT: 40,// 左边留白
    PADDING_RIGHT: 20,// 右边留白
    FONT_SIZE: 10, //字体字号
    FONT_COLOR: '#333333', //字体颜色
    LABEL_HEIGHT: 20, // 标签高度(胎心与宫缩间隔距离)
    START_GRID_COUNT: 0, // 前面空出0格
    END_GRID_COUNT: 0, // 最后空出6格
    MANUAL_MOVE_FLAG_COLOR: '#AEB9FE', // 手动胎动标记
    AFM_FLAG_COLOR: '#28CEBC', // 自动胎动标记
    TOCO_RESET_FLAG_COLOR: '#3F9EFF', // 宫缩复位标记
    X_GRID_SPACING: 12 // X轴网格间距(秒) 每个格子12秒
  },
  // 胎心率(FHR)曲线配置
  FHR: {
    Y_GRID_SIZE: 10, //Y轴网格间距  每个格子宽度
    X_GRID_SIZE: '', //x轴网格间距  每个格子宽度
    HEIGHT: '', // 胎心网格高度
    COLORS: ['#575757'], // 曲线颜色[胎儿A]
    SAFE_MIN: 110, // 安全范围下限(bpm)
    SAFE_MAX: 160, // 安全范围上限(bpm)
    SAFE_ZONE_COLOR: '#98DA9C', // 安全区域颜色
    Y_LABELS: [60, 90, 120, 150, 180, 210], // Y轴刻度值
    RANGE_MIN: 50, // Y轴最小值(bpm)
    RANGE_MAX: 220, // Y轴最大值(bpm)
    Y_GRID_SPACING: 10, // Y轴网格间距(bpm)
    Y_GRID_COUNT: '', // Y轴网格数量
    X_GRID_COUNT: 50, // X轴网格数量 每5个格子为1分钟
  },

  // 宫缩(TOCO)曲线配置
  CONTRACTION: {
    Y_GRID_SIZE: 10, //Y轴网格间距  每个格子宽度
    X_GRID_SIZE: '', //x轴网格间距  每个格子宽度
    HEIGHT: '', // 宫缩网格高度
    COLOR: '#575757', // 宫缩曲线颜色
    Y_LABELS: [0, 20, 40, 60, 80, 100], // Y轴刻度值
    RANGE_MIN: 0, // Y轴最小值TOCO
    RANGE_MAX: 100, // Y轴最大值TOCO
    Y_GRID_SPACING: 10, // Y轴网格间距TOCO
    Y_GRID_COUNT: '', // Y轴网格数量
    X_GRID_COUNT: 50, // X轴网格数量 每12个格子为1分钟
  },
  // 数据生成配置
  DATA: {
    TOTAL_DURATION: 600, // 总时长(秒)
    VIEWPORT_DURATION: 600, // 可视窗口时长(秒)
  },
};
export default {
  props: {
    canvasId: String,
    list: {
      type: Array,
      default: () => []
    },
    currentTime: { // 视图结束时间(秒)
      type: Number,
      default: 0
    },
    viewportStart: { // 视图起始时间(秒)
      type: Number,
      default: 0
    },
  },
  data () {
    return {
      ctx: null,
      canvasWidth: '',
      canvasHeight: '',
      displayList: [], // 当前显示数据
    }
  },
  mounted () {
    this.getWidthAndHeight()
  },
  methods: {
    getWidthAndHeight () {
      const element = this.$refs.boxView;
      if (element) {
        CONFIG.CANVAS.WIDTH = this.canvasWidth = element.offsetWidth;
        CONFIG.CANVAS.VIEWPORT_WIDTH = CONFIG.CANVAS.WIDTH - CONFIG.CANVAS.PADDING_LEFT - CONFIG.CANVAS.PADDING_RIGHT
        CONFIG.CANVAS.HEIGHT = this.canvasHeight = element.offsetHeight;
        this.configInit()
        this.$nextTick(() => {
          this.initCanvas()
        })
      } else {
        console.log('Element not found');
      }
    },
    configInit () {
      CONFIG.FHR.X_GRID_SIZE = CONFIG.CANVAS.VIEWPORT_WIDTH / CONFIG.FHR.X_GRID_COUNT
      CONFIG.FHR.Y_GRID_COUNT = (CONFIG.FHR.RANGE_MAX - CONFIG.FHR.RANGE_MIN) / CONFIG.FHR.Y_GRID_SPACING
      CONFIG.FHR.HEIGHT = CONFIG.FHR.Y_GRID_SIZE * CONFIG.FHR.Y_GRID_COUNT

      CONFIG.CONTRACTION.X_GRID_SIZE = CONFIG.CANVAS.VIEWPORT_WIDTH / CONFIG.CONTRACTION.X_GRID_COUNT
      CONFIG.CONTRACTION.Y_GRID_COUNT = (CONFIG.CONTRACTION.RANGE_MAX - CONFIG.CONTRACTION.RANGE_MIN) / CONFIG.CONTRACTION.Y_GRID_SPACING
      CONFIG.CONTRACTION.HEIGHT = CONFIG.CONTRACTION.Y_GRID_SIZE * CONFIG.CONTRACTION.Y_GRID_COUNT
    },
    initCanvas () {
      if (!this.ctx) {
        const canvas = document.getElementById(this.canvasId);
        this.ctx = canvas.getContext('2d');
      }
      return this.ctx
    },
    drawEmptyState () {
      this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      this.ctx.fillStyle = "#B6F3FF"
      this.ctx.fontSize = CONFIG.CANVAS.FONT_SIZE
      this.ctx.textBaseline = 'middle'
      this.ctx.textAlign = 'center'
    },
    drawChart () {
      if (!this.ctx) {
        setTimeout(() => {
          this.drawChart()
        }, 500)
        return ''
      };
      this.updateDisplayData()
      this.drawEmptyState();
      // 网格线颜色
      this.ctx.strokeStyle = CONFIG.CANVAS.GRID_COLOR;
      // 网格线宽
      this.ctx.lineWidth = CONFIG.CANVAS.GRID_LINE_WIDTH;
      // 绘制顺序：背景 → 曲线 → 标记
      // 开始绘制胎心区域
      this.drawFHR();
      // 网格线颜色
      this.ctx.strokeStyle = CONFIG.CANVAS.GRID_COLOR;
      // 网格线宽
      this.ctx.lineWidth = CONFIG.CANVAS.GRID_LINE_WIDTH;
      // 开始绘制宫缩区域
      this.drawContraction();
      // this.drawCurrentTimeMarker();
      //绘制胎心数据
      this.drawFHRCurves()

    },
    drawContraction () {
      if (!this.ctx) return;
      const ctx = this.ctx;
      // canvas顶部到宫缩的间距
      const paddingTop = CONFIG.CANVAS.PADDING_TOP + CONFIG.FHR.HEIGHT + CONFIG.CANVAS.LABEL_HEIGHT
      // 绘制宫缩纵向网格（基于GRID_SIZE）
      this.drawContractionVerticalGird(ctx, paddingTop)
      // 绘制宫缩横向网格（基于GRID_SIZE）
      this.drawContractionHorizontalGird(ctx, paddingTop)
      // 绘制宫缩纵向标签
      this.drawContractionVerticalLabels(ctx, paddingTop)
    },
    drawContractionVerticalGird (ctx, paddingTop) {
      for (let y = 0; y <= CONFIG.CONTRACTION.Y_GRID_COUNT; y++) {
        ctx.beginPath();
        ctx.moveTo(CONFIG.CANVAS.PADDING_LEFT, paddingTop + CONFIG.CONTRACTION.Y_GRID_SIZE * y);
        ctx.lineTo(this.canvasWidth - CONFIG.CANVAS.PADDING_RIGHT, paddingTop + CONFIG.CONTRACTION.Y_GRID_SIZE * y);
        ctx.stroke();
      }
    },
    drawContractionHorizontalGird (ctx, paddingTop) {
      for (let x = 0; x <= CONFIG.CONTRACTION.X_GRID_COUNT; x++) {
        ctx.beginPath();
        ctx.moveTo(CONFIG.CANVAS.PADDING_LEFT + CONFIG.CONTRACTION.X_GRID_SIZE * x, paddingTop);
        ctx.lineTo(CONFIG.CANVAS.PADDING_LEFT + CONFIG.CONTRACTION.X_GRID_SIZE * x, paddingTop + CONFIG.CONTRACTION.HEIGHT);
        ctx.stroke();
      }
    },
    drawContractionVerticalLabels (ctx, paddingTop) {
      ctx.fillStyle = CONFIG.CANVAS.FONT_COLOR;
      CONFIG.CONTRACTION.Y_LABELS.forEach(i => {
        ctx.fillText(i, CONFIG.CANVAS.PADDING_LEFT - 15, this.contractionValueToY(i));
      })
    },
    drawFHR () {
      if (!this.ctx) return;
      const ctx = this.ctx;
      // 绘制胎心安全区域
      this.drawFHRSafeZone(ctx)
      // 绘制胎心纵向网格（基于GRID_SIZE）
      this.drawFHRVerticalGird(ctx)
      // 绘制胎心横向网格（基于GRID_SIZE）
      this.drawFHRHorizontalGird(ctx)
      // 绘制胎心纵向标签
      this.drawFHRVerticalLabels(ctx)
      // 绘制胎心横向标签
      this.drawFHRHorizontalLabels(ctx)

    },
    drawFHRCurves () {
      if (!this.ctx || this.displayList.length === 0) return;
      const ctx = this.ctx;
      ctx.lineWidth = CONFIG.FHR.LINE_WIDTH;
      //绘制胎心1
      ctx.strokeStyle = CONFIG.FHR.COLORS[0];
      let isStart = true //下一个点是否为起点
      ctx.beginPath();
      this.displayList.forEach((item, i) => {
        if (item.fhr.draw) {
          const x = this.timeToX(item.timerPoint) + CONFIG.CANVAS.START_GRID_COUNT * CONFIG.FHR.X_GRID_SIZE;
          const y = this.fhrValueToY(item.fhr.value);
          if (isStart) {
            ctx.moveTo(x, y);
            isStart = false
          } else {
            ctx.lineTo(x, y);
          }
        } else {
          isStart = true
        }
      });
      ctx.stroke();
      //绘制宫缩
      ctx.strokeStyle = CONFIG.CONTRACTION.COLOR;
      isStart = true //下一个点是否为起点
      ctx.beginPath();
      // canvas顶部到宫缩的间距
      const paddingTop = CONFIG.CANVAS.PADDING_TOP + CONFIG.FHR.HEIGHT + CONFIG.CANVAS.LABEL_HEIGHT
      this.displayList.forEach((item, i) => {
        if (item.toco > 0) {
          const x = this.timeToX(item.timerPoint) + CONFIG.CANVAS.START_GRID_COUNT * CONFIG.FHR.X_GRID_SIZE;
          const y = this.contractionValueToY(item.toco);
          if (isStart) {
            ctx.moveTo(x, y);
            isStart = false
          } else {
            ctx.lineTo(x, y);
          }
        } else {
          isStart = true
        }
      });
      ctx.stroke();

      //绘制标记
      const y = this.fhrValueToY(200);
      const lineWith = 2
      const r = 3
      this.displayList.forEach((item, i) => {
        const x = this.timeToX(item.timerPoint) + CONFIG.CANVAS.START_GRID_COUNT * CONFIG.FHR.X_GRID_SIZE;
        // 自动胎动标记
        if (item.afmFlag) {
          ctx.beginPath();
          ctx.strokeStyle = CONFIG.CANVAS.AFM_FLAG_COLOR;
          ctx.fillStyle = CONFIG.CANVAS.AFM_FLAG_COLOR;
          ctx.arc(x, y, r, 0, Math.PI * 2);
          ctx.fill()
          ctx.stroke();
        }
        // 手动胎动标记
        if (item.manualMoveFlag) {
          ctx.beginPath();
          ctx.strokeStyle = CONFIG.CANVAS.MANUAL_MOVE_FLAG_COLOR;
          ctx.fillStyle = CONFIG.CANVAS.MANUAL_MOVE_FLAG_COLOR;
          ctx.arc(x, y, r, 0, Math.PI * 2);
          ctx.fill()
          ctx.stroke();
        }
        // 宫缩复位标记
        if (item.tocoResetFlag) {
          ctx.beginPath();
          ctx.lineWidth = lineWith;
          ctx.strokeStyle = CONFIG.CANVAS.TOCO_RESET_FLAG_COLOR;
          ctx.fillStyle = CONFIG.CANVAS.TOCO_RESET_FLAG_COLOR;
          ctx.moveTo(x - CONFIG.FHR.Y_GRID_SIZE / 2, y);
          ctx.lineTo(x + CONFIG.FHR.Y_GRID_SIZE / 2, y);
          ctx.moveTo(x, y - CONFIG.FHR.Y_GRID_SIZE / 2);
          ctx.lineTo(x, y + CONFIG.FHR.Y_GRID_SIZE / 2);
          ctx.stroke();
        }
      });

    },
    timeToX (time) {
      return CONFIG.CANVAS.PADDING_LEFT + (time - this.viewportStart) * CONFIG.FHR.X_GRID_SIZE / CONFIG.CANVAS.X_GRID_SPACING
    },
    fhrValueToY (val) {
      return CONFIG.CANVAS.PADDING_TOP + (CONFIG.FHR.RANGE_MAX - val) / CONFIG.FHR.Y_GRID_SPACING * CONFIG.FHR.Y_GRID_SIZE
    },
    contractionValueToY (val) {
      return CONFIG.CANVAS.PADDING_TOP + CONFIG.FHR.HEIGHT + CONFIG.CANVAS.LABEL_HEIGHT + (CONFIG.CONTRACTION.RANGE_MAX - val) / CONFIG.CONTRACTION.Y_GRID_SPACING * CONFIG.CONTRACTION.Y_GRID_SIZE
    },
    drawFHRVerticalGird (ctx) {
      for (let y = 0; y <= CONFIG.FHR.Y_GRID_COUNT; y++) {
        ctx.beginPath();
        ctx.moveTo(CONFIG.CANVAS.PADDING_LEFT, CONFIG.CANVAS.PADDING_TOP + CONFIG.FHR.Y_GRID_SIZE * y);
        ctx.lineTo(this.canvasWidth - CONFIG.CANVAS.PADDING_RIGHT, CONFIG.CANVAS.PADDING_TOP + CONFIG.FHR.Y_GRID_SIZE * y);
        ctx.stroke();
      }
    },
    drawFHRHorizontalGird (ctx) {
      for (let x = 0; x <= CONFIG.FHR.X_GRID_COUNT; x++) {
        ctx.beginPath();
        ctx.moveTo(CONFIG.CANVAS.PADDING_LEFT + CONFIG.FHR.X_GRID_SIZE * x, CONFIG.CANVAS.PADDING_TOP);
        ctx.lineTo(CONFIG.CANVAS.PADDING_LEFT + CONFIG.FHR.X_GRID_SIZE * x, CONFIG.CANVAS.PADDING_TOP + CONFIG.FHR.HEIGHT);
        ctx.stroke();
      }
    },
    drawFHRVerticalLabels (ctx) {
      ctx.fillStyle = CONFIG.CANVAS.FONT_COLOR;
      CONFIG.FHR.Y_LABELS.forEach(i => {
        ctx.fillText(i, CONFIG.CANVAS.PADDING_LEFT - 15, this.fhrValueToY(i));
      })
    },
    drawFHRHorizontalLabels (ctx) {
      const sec = this.viewportStart % 60
      let min = (this.viewportStart - sec) / 60
      for (let i = 0; i < 11; i++) {
        const x = CONFIG.CANVAS.START_GRID_COUNT * CONFIG.FHR.X_GRID_SIZE + CONFIG.FHR.X_GRID_SIZE * (60 / CONFIG.CANVAS.X_GRID_SPACING) * i - sec * (CONFIG.FHR.X_GRID_SIZE / CONFIG.CANVAS.X_GRID_SPACING) + CONFIG.CANVAS.PADDING_LEFT;
        const y = CONFIG.CANVAS.PADDING_TOP + CONFIG.FHR.HEIGHT + CONFIG.CANVAS.LABEL_HEIGHT / 2
        ctx.fillText(`${i + min}分钟`, x, y);
      }
    },
    drawFHRSafeZone (ctx) {
      ctx.fillStyle = CONFIG.FHR.SAFE_ZONE_COLOR;
      /**
       * fillRect(x, y, width, height)
       * y是顶部间距px+(Y轴最大值220bpm-安全范围上限160bpm)/Y轴标签间距10bpm*网格间距px
       * height是(安全范围上限160bpm-安全范围下限110bpm)/Y轴标签间距10bpm*网格间距px
       */
      ctx.fillRect(
        CONFIG.CANVAS.PADDING_LEFT,
        this.fhrValueToY(CONFIG.FHR.SAFE_MAX),
        this.canvasWidth - CONFIG.CANVAS.PADDING_LEFT - CONFIG.CANVAS.PADDING_RIGHT,
        (CONFIG.FHR.SAFE_MAX - CONFIG.FHR.SAFE_MIN) / CONFIG.FHR.Y_GRID_SPACING * CONFIG.FHR.Y_GRID_SIZE
      );
    },
    /**
     * 更新当前显示数据
     * 根据视窗范围和时间进度筛选数据
     */
    updateDisplayData () {
      const endTime = this.viewportStart + CONFIG.DATA.VIEWPORT_DURATION - CONFIG.CANVAS.START_GRID_COUNT * CONFIG.CANVAS.X_GRID_SPACING;
      const viewportStart = this.viewportStart - CONFIG.CANVAS.START_GRID_COUNT * CONFIG.CANVAS.X_GRID_SPACING
      const currentTime = this.currentTime - CONFIG.CANVAS.START_GRID_COUNT * CONFIG.CANVAS.X_GRID_SPACING
      this.displayList = this.list.filter(item =>
        item.timerPoint >= viewportStart &&
        item.timerPoint <= endTime &&
        item.timerPoint <= currentTime
      );
    },
  }
}
</script>

<style lang="less">
.boxView {
  width: 100%;
  height: 310px;
}
</style>